import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d688283c")

_pushScopeId("data-v-d688283c")
const _hoisted_1 = { class: "ques" }
const _hoisted_2 = { class: "q-cont" }
const _hoisted_3 = {
  key: 0,
  class: "answer-area"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("dt", null, "答案：", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("dt", null, "得分：", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("dt", null, "解析：", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.quesData.totalSort ? _ctx.quesData.totalSort + '.' : ''), 1),
      _createVNode("span", {
        innerHTML: _ctx.quesData.questionContent
      }, null, 8, ["innerHTML"]),
      _createTextVNode(_toDisplayString(_ctx.quesData.score ? '（' + _ctx.quesData.score + '分）' : ''), 1)
    ]),
    _createVNode(_component_el_checkbox_group, {
      modelValue: _ctx.checkList,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkList = $event)),
      class: "q-cb-group",
      onChange: _ctx.handleOptionChange
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.quesData.options, (item) => {
          return (_openBlock(), _createBlock(_component_el_checkbox, {
            label: item.value,
            key: item.value
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(item.value) + ".", 1),
              _createVNode("span", {
                innerHTML: item.content
              }, null, 8, ["innerHTML"])
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "onChange"]),
    (_ctx.showAnswer)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("dl", null, [
            _hoisted_4,
            _createVNode("dd", null, _toDisplayString(_ctx.rightAnswer), 1)
          ]),
          _createVNode("dl", null, [
            _hoisted_5,
            _createVNode("dd", null, _toDisplayString(_ctx.quesData.studentScore), 1)
          ]),
          _createVNode("dl", null, [
            _hoisted_6,
            _createVNode("dd", null, _toDisplayString(_ctx.quesData.analysis ? _ctx.quesData.analysis : '略'), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})